import { getCookieValue } from '../../utils/cookieUtils';

type Country = {
  text: string;
  value: string;
};

export default function useDefaultHomeCountryCode() {
  const { config } = window.appAirDrop;
  const { showCountry, homePageUrl } = config;
  const getDefaultHomeCountryCode = (): string => {
    if (!showCountry) {
      const countries: readonly Country[] = config?.createAccountCountries ?? [];
      // value order will be: cookie geotargetchosenlocale > cookie geotargetsite > config?.defaultCreateAccountHomeCountry > US
      // eslint-disable-next-line max-len
      const potentialDefaultHomeCountryCode: string | undefined = getCookieValue('geotargetchosenlocale') ?? getCookieValue('geotargetsite') ?? config?.defaultCreateAccountHomeCountry;
      const defaultHomeCountry = countries.find((c: Country): boolean => c?.value === potentialDefaultHomeCountryCode) ?? {
        value: 'US',
      };

      if (defaultHomeCountry.value === '--') {
        return '';
      }

      return defaultHomeCountry.value;
    }

    return '';
  };

  const getDefaultHomeCountry = (): Country => {
    if (showCountry) {
      const countries: readonly Country[] = config?.createAccountCountries ?? [];
      const potentialDefaultHomeCountryCode: string | undefined = getCookieValue('geotargetchosenlocale')
        ?? getCookieValue('geotargetsite')
        ?? config?.defaultCreateAccountHomeCountry;
      const defaultHomeCountry = countries.find((c: Country): boolean => c?.value === potentialDefaultHomeCountryCode) ?? {
        text: '',
        value: '',
      };

      if (defaultHomeCountry.text === '--' || defaultHomeCountry.value === '--') {
        return {
          text: '',
          value: '',
        };
      }
      return defaultHomeCountry;
    }

    return {
      text: '',
      value: '',
    };
  };

  const logoRedirectUrl = (): string => {
    if (homePageUrl) {
      if (homePageUrl?.urlsByCountry) {
        return Object.keys(homePageUrl?.urlsByCountry).includes(getDefaultHomeCountryCode())
          ? homePageUrl?.urlsByCountry?.[getDefaultHomeCountryCode()]
          : homePageUrl?.defaultUrl;
      }
      return homePageUrl?.defaultUrl;
    }
    return '';
  };

  return { getDefaultHomeCountryCode, getDefaultHomeCountry, logoRedirectUrl };
}
